import API from './API';

export default class UnderlyingAssetTypeAPI extends API {
  constructor(parameters = {}) {
    super('/UnderlyingAssetType', parameters);
  }

  getUnderlyingAssetType() {
    return this.submit("get", `${this.endpoint}`);
  }
}
